import React from 'react'
import ProductsCard from './ProductsCard'
import Maintenance from './extra/Maintenance';
import Loading from './extra/Loading';

function Products({products,fetch}) {
  
  console.log(products);
  console.log('child:', fetch);

  return (
    <div className='py-5'>
        <div className='max-w-screen grid grid-cols-2 lg:grid-cols-3 gap-3'> 
            {
              fetch===false && products.length === 0 ? <Loading/> : ""
            }
            {
              products.length!==0 ?
              products.map((item)=>(
                <ProductsCard key={item.id} product={item} />
              ))
              :  <>{/* <Maintenance/> */}  </>
            }
            {
              fetch ? <Maintenance /> : ""
            }
        </div>
    </div>
  )
}

export default Products